export const UNIVERSES = [
  {
    key: "afro",
    path: "/coiffure-afro-professionnelle",
    short: "Coiffure afro",
    title: "Coiffure afro et cheveux texturés",
    image: "/img/home/univers-afro.webp",
    alt: "Coiffeuse appliquant un soin sur des cheveux crépus naturels dans un salon afro",
    teaser: "Soins, crèmes, sérums et gamme locks pour les spécialistes des cheveux crépus, frisés, bouclés et texturés.",
    seoTitle: "Coiffure afro professionnelle : produits pour cheveux crépus et texturés | Ozentya",
    seoDesc: "Fournisseur de produits de coiffure afro pour professionnels : shampoings, crèmes, sérums, soins locks et edge control pour cheveux crépus, frisés et bouclés. Prix HT, livraison en France.",
    h1: "Produits professionnels pour la coiffure afro et les cheveux texturés",
    intro: [
      "Les cheveux crépus, frisés et bouclés demandent des soins qui hydratent sans alourdir, facilitent le démêlage et respectent un cuir chevelu souvent sollicité par les coiffures protectrices. C'est le cœur de métier d'Ozentya depuis ses débuts.",
      "Les salons afro, les spécialistes des locks, des tresses et des coiffures naturelles trouvent ici des soins à utiliser au bac et en finition, et des produits à proposer à la revente à leur clientèle.",
    ],
    points: [
      ["Cuir chevelu et pousse", "La lotion Extrême Repouss (classique et cheveux fins) accompagne les clientes aux tempes fragilisées, en complément de vos conseils."],
      ["Hydratation et démêlage", "Shampoing et crème Cactus, crème Aloe Vera ultra démêlante, Masque Suprême : la base d'une routine hydratation."],
      ["Locks et finitions", "Shampooing, huile et spray Locks pour l'entretien des dreadlocks, Edge Control pour des baby hairs nettes."],
    ],
  },
  {
    key: "europeenne",
    path: "/coiffure-europeenne-professionnelle",
    short: "Coiffure européenne",
    title: "Coiffure européenne",
    image: "/img/home/univers-europeenne.webp",
    alt: "Coiffeuse réalisant un shampoing au bac dans un salon de coiffure mixte",
    teaser: "Shampoings, après-shampooing, masques et soins du cuir chevelu pour les salons mixtes et les coiffeurs indépendants.",
    seoTitle: "Coiffure européenne professionnelle : soins et shampoings pour salons | Ozentya",
    seoDesc: "Produits de coiffure professionnels pour salons mixtes et coiffeurs indépendants : shampoing à l'argan, après-shampooing, masque réparateur, antipelliculaire. Prix HT, livraison en France.",
    h1: "Produits professionnels pour la coiffure européenne et les salons mixtes",
    intro: [
      "Un salon mixte reçoit chaque jour des cheveux fins, raides, ondulés, colorés ou abîmés. Les soins Ozentya sélectionnés ici conviennent à ces différentes natures de cheveux et s'intègrent facilement à vos prestations au bac.",
      "Coiffeurs indépendants, salons de quartier ou à domicile : composez vos commandes à l'unité de conditionnement, avec des prix HT clairs.",
    ],
    points: [
      ["Lavage et soin au bac", "Shampooing à l'argan adulte et junior, après-shampooing ricin et jojoba, Masque Suprême réparateur."],
      ["Cuir chevelu", "Shampooing antipelliculaire pour les cuirs chevelus secs et irrités."],
      ["Cheveux fins", "Extrême Repouss Cheveux Fins, version légère et non grasse pour les cheveux qui regraissent vite."],
    ],
  },
  {
    key: "barber",
    path: "/barber-shop-professionnel",
    short: "Barber shop",
    title: "Barber shop et coiffure masculine",
    image: "/img/home/univers-barber.webp",
    alt: "Barbier appliquant une huile sur une barbe dans un barbershop contemporain",
    teaser: "Huiles à barbe en quatre parfums, shampoing pour barbe, edge control et soins du cuir chevelu pour barbiers et barbershops.",
    seoTitle: "Produits pour barber shop et barbiers professionnels | Ozentya",
    seoDesc: "Fournisseur barber shop : huiles à barbe (normal, cerise, patchouli, tropicale), edge control et shampooing antipelliculaire pour barbiers professionnels. Prix HT, livraison en France.",
    h1: "Produits professionnels pour barber shop et barbiers",
    intro: [
      "Dans un barbershop, la finition fait la différence : une barbe nourrie et brillante, des contours nets, un cuir chevelu sain après la tondeuse.",
      "Ozentya propose aux barbiers une gamme courte et efficace, à utiliser en prestation et à revendre au comptoir.",
    ],
    points: [
      ["Soin de la barbe", "Shampoing pour barbe 250 ml, puis huile à barbe en quatre versions : Normal, Cerise, Patchouli et Tropicale."],
      ["Contours et finitions", "Edge Control fixation forte, fini brillant naturel, sans résidus."],
      ["Cuir chevelu", "Shampooing antipelliculaire pour apaiser les cuirs chevelus secs."],
    ],
  },
];

export const universeByKey = (k) => UNIVERSES.find((u) => u.key === k);
